import { collection, onSnapshot, orderBy, query } from "firebase/firestore";
import { useEffect, useState } from "react";
import useAddProduct from "../api/useAddProduct";
import useDeleteProduct from "../api/useDeleteProduct";
import useDeleteProducts from "../api/useDeleteProducts";
import useUpdateProduct from "../api/useUpdateProduct";
import { db } from "../firebase";
import { FavoritesList } from "./FavoritesList";
import { AddProduct } from "./forms/AddProduct";
import { ConfirmDeleteModal } from "./generic/DeleteConfirmationModal";
import { TileList } from "./generic/TileList";
import Product from "./Product";
import { ProductListFooter } from "./ProductListFooter";
import { RecipesList } from "./RecipesList";

function ProductList({ selectedList }) {
  const [products, setProducts] = useState([]);
  const [addModalOpen, setAddModalOpen] = useState(false);
  const [favoritesOverlayOpen, setFavoritesOverlayOpen] = useState(false);
  const [recipesOverlayOpen, setRecipesOverlayOpen] = useState(false);
  const [deleteAllModalOpen, setDeleteAllModalOpen] = useState(false);

  useEffect(() => {
    const productsCollectionRef = collection(
      db,
      "lists",
      selectedList.id,
      "products",
    );
    const productsQuery = query(productsCollectionRef, orderBy("name", "desc"));

    const unsubscribeProducts = onSnapshot(
      productsQuery,
      (productsSnapshot) => {
        const fetchedProducts = productsSnapshot.docs.map((d) => ({
          id: d.id,
          ...d.data(),
        }));

        const sortedProducts = fetchedProducts.sort((a, b) =>
          a.name.localeCompare(b.name, "de"),
        );

        setProducts(sortedProducts);
      },
      (error) => {
        console.error(
          `Error fetching products for list ${selectedList.id}:`,
          error,
        );
      },
    );

    return () => {
      unsubscribeProducts();
    };
  }, [selectedList.id]);

  const { deleteProduct } = useDeleteProduct();
  const { deleteProducts } = useDeleteProducts();
  const { updateProduct } = useUpdateProduct();
  const { addProduct } = useAddProduct();

  if (!products) return "Loading";

  return (
    <div>
      <h3>{selectedList.name}</h3>

      <div style={{ display: "grid", gridTemplateRows: "1fr 40px" }}>
        {products.length > 0 ? (
          <TileList>
            {products.map((product) => (
              <Product
                key={product.id}
                product={product}
                onDelete={() => {
                  deleteProduct(selectedList.id, product.id);
                }}
                onToggleChecked={(updates) => {
                  updateProduct(selectedList.id, product.id, updates);
                }}
              />
            ))}
          </TileList>
        ) : (
          <h2>Nix auf der Liste</h2>
        )}

        <ProductListFooter
          currentListId={selectedList.id}
          products={products}
          openAddModal={setAddModalOpen}
          openFavorites={setFavoritesOverlayOpen}
          openRecipes={setRecipesOverlayOpen}
          openDeleteAllModal={setDeleteAllModalOpen}
        />

        {/* MODALS */}

        {addModalOpen ? (
          <AddProduct
            onClose={() => setAddModalOpen(false)}
            onSubmit={(payload, closeModal) => {
              addProduct(selectedList.id, payload);
              if (closeModal) setAddModalOpen(false);
            }}
          />
        ) : null}

        {favoritesOverlayOpen ? (
          <FavoritesList
            listId={selectedList.id}
            onClose={() => setFavoritesOverlayOpen(false)}
            addProduct={(payload) => addProduct(selectedList.id, payload)}
            products={products}
          />
        ) : null}

        {recipesOverlayOpen ? (
          <RecipesList
            listId={selectedList.id}
            onClose={() => setRecipesOverlayOpen(false)}
            addProduct={(payload) => addProduct(selectedList.id, payload)}
            products={products}
          />
        ) : null}

        {deleteAllModalOpen ? (
          <ConfirmDeleteModal
            onClose={() => setDeleteAllModalOpen(false)}
            onSubmit={async () => {
              await deleteProducts(
                selectedList.id,
                products.map(({ id }) => id),
              );
              setDeleteAllModalOpen(false);
            }}
            // todo get loading
            // loading={loading}
            recordName="Ganze Liste"
            deleteButtonText="💣💣 Bumm Bumm"
          />
        ) : null}
      </div>
    </div>
  );
}

export default ProductList;
